import { useState } from "react";
import { MessageCircle, Check } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { act } from "@/lib/useApi";
import { brl, dt } from "@/lib/fmt";

export function BulkReminderDialog({ overdue, onClose, onDone }) {
  const byStudent = Object.values(overdue.reduce((acc, p) => {
    if (!acc[p.student_id] || p.due_date < acc[p.student_id].due_date) acc[p.student_id] = p;
    return acc;
  }, {}));
  const [idx, setIdx] = useState(0);
  const [done, setDone] = useState([]);
  const current = byStudent[idx];

  const sendNext = async () => {
    const win = window.open("", "_blank");
    const r = await act(() => api.get(`/payments/${current.id}/whatsapp`));
    if (r) { win.location.href = r.url; setDone((d) => [...d, current.id]); } else win.close();
    setIdx((i) => i + 1);
  };

  return (
    <Dialog open onOpenChange={(o) => !o && (onDone(), onClose())}>
      <DialogContent data-testid="bulk-reminder-dialog">
        <DialogHeader><DialogTitle className="font-display uppercase">Lembretes em massa · {byStudent.length} aluno(s)</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600">Cada clique abre o WhatsApp do próximo aluno com a mensagem pronta (uma cobrança por aluno, a mais antiga).</p>
        <div className="max-h-64 overflow-y-auto divide-y divide-slate-100 text-sm">
          {byStudent.map((p, i) => (
            <div key={p.id} className={`flex items-center justify-between py-2 ${i === idx ? "font-semibold" : ""}`} data-testid={`bulk-row-${p.id}`}>
              <span>{p.student_name}<span className="block text-xs text-slate-500 font-normal">{brl(p.amount)} · venceu {dt(p.due_date)}</span></span>
              {done.includes(p.id) ? <Check className="w-4 h-4 text-emerald-600" data-testid={`bulk-done-${p.id}`} /> : i < idx ? <span className="text-xs text-slate-400">pulado</span> : null}
            </div>))}
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => { onDone(); onClose(); }} data-testid="bulk-close-btn">Fechar</Button>
          {current ? <Button className="bg-emerald-600 hover:bg-emerald-700" onClick={sendNext} data-testid="bulk-send-next-btn"><MessageCircle className="w-4 h-4 mr-1" />Enviar para {current.student_name.split(" ")[0]} ({idx + 1}/{byStudent.length})</Button>
            : <span className="text-sm text-emerald-700 self-center" data-testid="bulk-finished">Todos enviados ({done.length})</span>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
